import { FC } from 'react';

import { useGetDashboardLinkQuery } from '@entities/metabase';
import ErrorMessage from '@shared/components/ErrorMessage';
import LoadingSpinner from '@shared/components/LoadingSpinner';

type IProps = {
  height?: string;
  width?: string;
};

export const ChartEmbed: FC<IProps> = ({ height = '100%', width = '100%' }) => {
  const { data, isLoading, isError, error } = useGetDashboardLinkQuery(undefined);

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (data.data?.dashboard_url) {
    return (
      <iframe
        title='Monitoring Dashboard'
        src={data.data.dashboard_url}
        width={width}
        height={height}
        frameBorder='0'
      ></iframe>
    );
  }

  return <div>No data</div>;
};
